// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see PrepurchaseCardToggleViewEvent
 */
export var PrepurchaseCardToggleView = function (_a) {
    var toggleState = _a.toggleState;
    return ({
        name: "PrepurchaseCard Toggle View",
        parameters: {
            cdf_entity: "PrepurchaseCard",
            cdf_action: "Toggle",
            toggle_state: toggleState !== undefined && toggleState !== null ? toggleState.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see PrepurchaseCardToggleTapEvent
 */
export var PrepurchaseCardToggleTap = function (_a) {
    var toggleState = _a.toggleState;
    return ({
        name: "PrepurchaseCard Toggle Tap",
        parameters: {
            cdf_entity: "PrepurchaseCard",
            cdf_action: "Toggle",
            toggle_state: toggleState !== undefined && toggleState !== null ? toggleState.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see PrepurchaseCardPrimaryHalfSheetViewEvent
 */
export var PrepurchaseCardPrimaryHalfSheetView = function () { return ({
    name: "PrepurchaseCard PrimaryHalfSheet View",
    parameters: {
        cdf_entity: "PrepurchaseCard",
        cdf_action: "PrimaryHalfSheet",
    }
}); };
/**
 * @see PrepurchaseCardPrimaryHalfSheetViewSubpageEvent
 */
export var PrepurchaseCardPrimaryHalfSheetViewSubpage = function (_a) {
    var subpageTitle = _a.subpageTitle;
    return ({
        name: "PrepurchaseCard PrimaryHalfSheet ViewSubpage",
        parameters: {
            cdf_entity: "PrepurchaseCard",
            cdf_action: "PrimaryHalfSheet",
            subpage_title: subpageTitle !== undefined && subpageTitle !== null ? subpageTitle.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see PrepurchaseCardCardTabPillTapEvent
 */
export var PrepurchaseCardCardTabPillTap = function () { return ({
    name: "PrepurchaseCard CardTabPill Tap",
    parameters: {
        cdf_entity: "PrepurchaseCard",
        cdf_action: "CardTabPill",
    }
}); };
/**
 * @see PrepurchaseCardAppletRowTapEvent
 */
export var PrepurchaseCardAppletRowTap = function () { return ({
    name: "PrepurchaseCard AppletRow Tap",
    parameters: {
        cdf_entity: "PrepurchaseCard",
        cdf_action: "AppletRow",
    }
}); };
